import { Collapsible } from "../collapsible";

export default class Documents {
  constructor($elem) {
    new Collapsible($elem.find(".accordion"));
  }
}
